// The game map: the 3D Scene with its click / hover / camera wiring.
// Extracted from App.tsx (ROADMAP 7.14); renders in the same DOM position.

import type { ComponentProps } from 'react';
import { Scene } from '../render/Scene.js';
import type { SimWorld } from '../sim/useSimWorld/index.js';
import type { Selection } from '../testBridge/useTestBridge.js';

type SceneProps = ComponentProps<typeof Scene>;

interface MatchBoardProps {
  sim: SimWorld;
  /** `sim.snapshot`, already narrowed non-null by App. */
  snapshot: SceneProps['snapshot'];
  selection: Selection;
  cameraRequest: SceneProps['focusRequest'];
  engagements: SceneProps['engagements'];
  currentTick: number;
  onTileHover: SceneProps['onTileHover'];
  onUnitHover: SceneProps['onUnitHover'];
  onTileClick: SceneProps['onTileClick'];
  onCityClick: SceneProps['onCityClick'];
  onUnitClick: SceneProps['onUnitClick'];
  onMoveClick: SceneProps['onMoveClick'];
  onBackgroundClick: () => void;
}

export function MatchBoard({
  sim,
  snapshot,
  selection,
  cameraRequest,
  engagements,
  currentTick,
  onTileHover,
  onUnitHover,
  onTileClick,
  onCityClick,
  onUnitClick,
  onMoveClick,
  onBackgroundClick,
}: MatchBoardProps) {
  return (
    <main aria-label="Game map" className="absolute inset-0">
      <Scene
        snapshot={snapshot}
        events={sim.events ?? []}
        climate={sim.climate}
        sea={sim.sea}
        onTileHover={onTileHover}
        onUnitHover={onUnitHover}
        onTileClick={onTileClick}
        onCityClick={onCityClick}
        onUnitClick={onUnitClick}
        onMoveClick={onMoveClick}
        onBuildBridge={(unitId, q, r) => {
          sim.buildBridge(unitId, q, r);
        }}
        onBackgroundClick={onBackgroundClick}
        selectedTileId={selection?.kind === 'tile' ? selection.id : null}
        selectedCityId={selection?.kind === 'city' ? selection.id : null}
        selectedUnitId={selection?.kind === 'unit' ? selection.id : null}
        focusRequest={cameraRequest}
        doctrine={sim.localPlayer?.dominant ?? null}
        engagements={engagements}
        currentTick={currentTick}
      />
    </main>
  );
}
